<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong style="margin-left: 0.9rem;">Update Shipment Status</strong>
            <div class="card-header-actions">     
              <button data-toggle="tooltip" title="Refresh" class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" style="margin-right:1.5rem" type="button"><i class="fa fa-refresh"></i></button>                   
            </div>
          </div>   
          <div class="box" id="addform">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >
                  <b-col sm="12" >
                  <b-form-group label="Select Vehicle"  :label-cols="4" >
               
                      <!-- <b-form-select class="form-control input" v-model="customer.vehicle_id" name="vehicle_id" v-validate="'required'" 
                      :class="{'input': true, 'text-danger': errors.has('form-1.vehicle_id') }" >
                        <option value="" >--Select--</option>
                        <option :value="customer.vehicle_id"  v-for="agent in vehicleitems" v-bind:value="agent.vehicle_id">{{ agent.vehicle_name}} - {{ agent.vehicle_no}}</option>
                        <span style="width: 270px;" v-show="errors.has('form-1.vehicle_id')" class="help text-danger">{{ errors.first('form-1.vehicle_id') }}</span> 
                  </b-form-select> -->
                  <v-select @input="selected_vehicleInfo(customer.vehicle_id)" v-model="customer.vehicle_id" :options="vehicle_items" placeholder="--Select--"  name="vehicle_id" v-validate="'required|'" 
                      :class="{'input': true, 'text-danger': errors.has('form-1.vehicle_id') }"></v-select>
                      <span style="width: 270px;" v-show="errors.has('form-1.vehicle_id')" class="help text-danger">{{ errors.first('form-1.vehicle_id') }}</span> 
                  </b-form-group>
                </b-col>
                </b-col>
                <b-col md="6" >
                 <b-button :disabled="customer.vehicle_id == '' || customer.vehicle_id == null" type="submit" size="md" class="mr-4" variant="primary">Search</b-button>
                </b-col>
              </b-row>               
            </form>
          </div>
<br>
           <b-col sm="12" >
            <!--  <b-button @click="markDelivered(row.item)"  variant="success" size="md" ><i class="fa fa-check" aria-hidden="true"></i>&nbsp;Approve</b-button>
             <b-button  @click="markNdr(row.item)" variant="danger" size="md" ><i class="fa fa-times" aria-hidden="true"></i>&nbsp;Approve</b-button> -->
             <span   style="cursor:pointer;">
              <span v-if="checkedvehicle.length >0">
                  <span    @click="!isReadOnly && markDelivered()" class="badge badge-success" style="font-size: 12px;margin-left: 5px;padding:10px" :class="{ 'disabled': isReadOnly }" >Mark Delivered</span>
                  <span    @click="!isReadOnly && markNdr()" class="badge badge-danger" style="font-size: 12px;margin-left: 5px;padding:10px" :class="{ 'disabled': isReadOnly }" >Mark NDR</span>
              </span>
            </span>
            <!-- <b-button v-if="selectedquoteid_length>1" size="md"  @click="Comparing_quote()" style="background-color:#e67e22;color:#fff;" ></b-button> -->

          <p style='float:right'> <b>Total Records :<span style="color:red;margin-right: 10px;">{{totalRows}}</span></b> </p>
              </b-col> 
          <b-col sm="12" >
           <b-table show-empty stacked="md" :busy="isBusy" :items="itemMark" :fields="fields"  :current-page="currentPage"  :per-page="perPage"  :outlined="outlined"  >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>  
          <template slot="checkbox" slot-scope="row">
            
              <span >
              <input  v-if="isCheckAll==false" type="checkbox" @change="multiselectdesign($event,row.item)" v-bind:value="row.item.parentawb" v-model="checkedvehicle"  >
            {{row.item.selected}}
            </span>
        
        </template> 
<!--                <template slot="actions" slot-scope="row">
                 <span   style="cursor:pointer;">
                    <span v-if="row.item.status==null" data-toggle="tooltip" title="Approve">
                    <span    @click="markDelivered(row.item)" class="badge badge-success" style="font-size: 12px;margin-left: 5px;">Mark Delivered</span>
                    <span    @click="markNdr(row.item)" class="badge badge-danger" style="font-size: 12px;margin-left: 5px;">Mark NDR</span>
                  </span>
                  <span v-else>
                    {{row.item.status}}
                  </span>
                  
                  </span>
               </template>     -->       
            </b-table>
          </b-col>

          <b-col md="12" class="my-1 " v-if="totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>   

           
             <!-- Code for Remark  Listing -->
      <b-modal size="md" title="Please Confirm" v-model="markDeliveredmodal" hide-footer>
         
<!--           <template slot="default" slot-scope="{ hide }"> -->
            <p><strong> Are you Really Want to Mark Delivered?</strong></p>
                 <div class="col-md-12 mb-4 text-center">
                               <b-button  variant="danger" style="float: right;" @click="markDeliveredcancel()" >
                              Cancel
                             </b-button>
                                <button   @click="markDelivered_Approve()" class="btn btn-success"  style="float: right;margin-right:10px;">
                                    Yes
                                </button>

                            </div>
                        
          <!-- </template> -->
          <!-- <template slot="modal-footer" slot-scope="{ hide }">
         
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            
          </template> -->
      </b-modal>  
      <b-modal size="md" title="Please Confirm" v-model="markNdrreason" @ok="markNdrreason = false" hide-footer>
         
          <template slot="default" slot-scope="{ hide }">
               <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">

                <b-form-group
                  label="NDR Reason"
                  :label-cols="4" >
                  <b-form-select type="text" name="selectedreason" v-model="selectedreason"  v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-5.selectedreason') }">
                     <option value="">--Select--</option>
                    
                    <option v-for="option in selectedndrList" v-bind:value="option.deliverystatuscode" >{{option.deliverystatuscode}} - {{option.deliverystatusname}}</option>
                  </b-form-select>
                 
                  <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('selectedreason')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.selectedreason')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.selectedreason') }}
                      </code>
                     
                      </b-input-group>
                                 
                </b-form-group>

                
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary">Update</b-button>
                  <b-button  size="sm" variant="danger" @click="markNDRcancel()">cancel</b-button>
                </div>
              </b-form>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
         
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            
          </template>
      </b-modal>  
<!--       <b-modal size="md" title="Please Confirm" v-model="markNdrmodal" @ok="markNdrmodal = false" hide-footer>
         
          <template slot="default" slot-scope="{ hide }">
            <p><strong> Are you Really Want to Mark NDR?</strong></p>
                 <div class="col-md-12 mb-4 text-center">
                               <b-button  variant="danger" style="float: right;" @click="markNDRcancel()" >
                              Cancel
                             </b-button>
                                <button   @click="markNDR_approve()" class="btn btn-success"  style="float: right;margin-right:10px;">
                                    Yes
                                </button>

                            </div>
                        
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
         
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            
          </template>
      </b-modal>  --> 



        </b-card>
      </b-col>
     </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      selected:'',
      name: 'allocation',
      data: [],
      DAPendingStatus: [],
      data1: [],
      pincodeallocatedata: [],
      allocatedata: [],
      toggleInfo: false,
      toggleInfo2: false,
      toggleDeAllocateInfo: false,
      allocated: [],
      customer: {},
      totalassgntxt: 'totalassgntxt',
      modalvalue: 'modalvalue',
      filterdata: [],
      filterdata1: [],
      filterdata2: [],
      shipment:"",
      alloctionId:"",
      isSearchDAPendingStatus: 0,
      DAAvaliablePickUPListData: 0,
      totalRows: 0,
      currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
      isBusy: false,
      outlined:true,
      isCheckAll:false,
      fields: [
      { key: 'checkbox', label: 'Select', sortable: true, sortDirection: 'desc' },
       { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
       { key: 'vehicle_no', label: 'Vehicle No', sortable: true},
          { key: 'invoiceno', label: 'Load ID', sortable: true},
          { key: 'invoicedate', label: 'Invoice Date', sortable: true},
          { key: 'mpscount', label: 'MPS Count', sortable: true},
          { key: 'valweight', label: 'Volumetric Weight', sortable: true},
          { key: 'sourceaddress', label: 'Source Address', sortable: true},
          { key: 'destinationaddress', label: 'Destination Address', sortable: true}, 
  
          { key: 'deliverystatus', label: 'Delivery Status', sortable: true },
          { key: 'shipmentstatus', label: 'Shipment Status', sortable: true },
          // { key: 'status', label: 'Shipment Status', sortable: true },
           // { key: 'actions', label: 'Action', sortable: true, sortDirection: 'desc' },
      ],
      itemMark:[],

      markDeliveredmodal:false,
      markNdrmodal:false,
      markNdrreason:false,
      vehicleitems:[],
        vehicle_items: [],
        deliveryagent:"",
        shippingid:'',
        checkedvehicle:[],
       selectedvehicle:[],
       selectedndrList:[],
       selectedreason:'',
       accessBody:[],
      isReadOnly:false,
    }
  },
  created: function() {
    var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);

      this.accessBody = userInfo.body;
      this.ischeckbodyvalidation();
    this.displaydata()
  },
  methods: {
    ischeckbodyvalidation(){
      for (let i = 0; i < this.accessBody.length; i++) {
        const element = this.accessBody[i];
     
        // if (element.title=='Mark Booking Done' && element.isReadonly==true && this.route_id=='normal') {
        //   this.isReadOnly=true
        // }
       if (element.child) {
        for (let j = 0; j < element.child.length; j++) {
          const k = element.child[j];
           if (k.title=='Mark Booking Done' && k.isReadonly==true) {
            this.isReadOnly=true
          }
        }
       }
      }
      console.log(" this.isReadOnly", this.isReadOnly)
    },
    selected_vehicleInfo:function(value){
          if (value==null) {
            // this.selected_vehicleno="";
            this.displaydata()
          
          }
      },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.showData()
        }
      })
    },
multiselectdesign(e,value){
      
        if (this.checkedvehicle.length >=0)

        {
          this.selectedvehicle=this.checkedvehicle;
          console.log("HHHHH",this.selectedvehicle);
          // alert("in");
          console.log("JJJJJJJJJJ",this.checkedvehicle);

            
          
          // if (e.target.checked==true){
          //   // alert("in");
            
          // }else{
       
          // }


        }
       

    },
    
       displaydata: function() {
     
      // this.isBusy = true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const deliveryagentobj = {
        sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`,
          isactive:'1',
      };
      console.log('deliveryagentobj',deliveryagentobj);
      this.$http
        .post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getVehicleListing`,
          deliveryagentobj
        )
        .then(result => {
          console.log("YYY",result);
          if (result.body.length > 0) {
            // this.isBusy = !this.isBusy
            this.data = result.body;
           
            this.vehicleitems  = result.body;
             
            for (let i = 0; i <  this.vehicleitems.length; i++) {
                var vehicle_idDetails =  this.vehicleitems[i].vehicle_no + "-" +  this.vehicleitems[i].vehicle_id + "-" +  this.vehicleitems[i].vehicle_name;
                this.vehicle_items.push(vehicle_idDetails)
              }
          } else {
            // this.isBusy = !this.isBusy
            this.data = result.body;
            this.vehicleitems  = result.body;
            // this.totalRows = result.body.length
          }
        })
        .catch(ex => {
          console.log("error", ex);
        });
     
    },
     GetSortOrder : function(prop) {
        return function(a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        }

    },
    showData: function() {
         var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      console.log(this.customer.vehicle_id)
      this.isBusy = true;
      if (this.customer.vehicle_id != undefined) {
        var searchvehiclearr = [];
      searchvehiclearr = this.customer.vehicle_id.split('-')
      console.log("@@@@@@@@@@@@",searchvehiclearr[1])
      var vehicle_id = searchvehiclearr[1];
      }
      // this.isBusy2 = true;
      const obj = {
        // sysusermasterid:`${userInfo.sysusermasterid}`,
        // usertype:`${userInfo.user_type}`,
        vehicleid:vehicle_id,
      }
      // console.log("obj",obj);
     this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getBookingDoneLoadListingAgainstVehicle`,obj)
        .then((result) => {
          this.isBusy = false;
         // console.log("Result",result);
           if (result.body.returnmsg == 'Successful') {
            
            // console.log('Data',this.data);
            this.itemMark  = result.body.returnvalue;
            console.log("itemMark",this.itemMark);
            // this.imgpath=result.body.returnvalue;
            // console.log("image",this.imgpath);
            // this.agenti
            this.totalRows = result.body.returnvalue.length
            console.log("TotalsRow", this.totalRows);
          } else {
            this.isBusy = false;
            this.itemMark  = [];
             this.totalRows = 0;
            // this.totalRows = result.body.returnvalue.length
          }
        
         
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    markDelivered:function(){
      this.markDeliveredmodal=true;
    },
    markDelivered_Approve:function(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      
      // if (this.customer.vehicle_id != "") {
        var searchvehiclearr = [];
      searchvehiclearr = this.customer.vehicle_id.split('-')
      console.log("@@@@@@@@@@@@",searchvehiclearr[1])
      var vehicle_id = searchvehiclearr[1];
      // }

        var requestObj = {
        parentawb:this.selectedvehicle,
        vehicleid:vehicle_id,
        deliverystatuscode:'',
        shipmentstatus:'Delivered',
        lastmodifiedby:`${userInfo.sysemailid}`,

      };
      console.log("requestObj",requestObj);
      // return false;
       this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/consignmentMasterMarkOfdByAdmin`,
            requestObj
          )
          .then(result => {
            if (result.body.returnmsg == 'Successful') {
               this.$fire({
                text: "Shipment Status Successfully Chanage to Delivered",
                type: "success",
                timer: 30000
                }); 
               this.checkedvehicle=[];
               this.showData();
               this.markDeliveredmodal=false;
            }else{
              this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 
            }
    
          })

          .catch(ex => {
            console.log("error", ex);
          });
          // this.showData();

    },
    markDeliveredcancel:function(){
      this.markDeliveredmodal=false;
    },
    markNdr:function(){
      this.markNdrreason=true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      
        var ndrlistObj = {
            isactive:'1',
            service_type:'Delivery',

      };
      console.log("ndrlistObj",ndrlistObj);
      // return false;
       this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/getdeliverystatusmasterlist`,
            ndrlistObj
          )
          .then(result => {
            // console.log("HHH",result);
            if (result.body.returnmsg == 'Successful') {
               this.selectedndrList=result.body.returnvalue;
               // console.log("JJJJ",this.selectedndrList);
            }else{
              this.selectedndrList=[];
            }
    
          })

          .catch(ex => {
            console.log("error", ex);
          });
    },
       validateForm5(scope) {
      // alert("innnnn");
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          
           this.ndrList();
        }
      });
    },
    ndrList:function(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var ndrcode=this.selectedreason.toString();
      
      // if (this.customer.vehicle_id != "") {
        var searchvehiclearr = [];
      searchvehiclearr = this.customer.vehicle_id.split('-')
      console.log("@@@@@@@@@@@@",searchvehiclearr[1])
      var vehicle_id = searchvehiclearr[1];
      // }

        var requestObj = {
        parentawb:this.selectedvehicle,
        vehicleid:vehicle_id,
        deliverystatuscode:ndrcode,
        shipmentstatus:'NDR',
        lastmodifiedby:`${userInfo.sysemailid}`,

      };
      console.log("requestObj",requestObj);
      // return false;
       this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/consignmentMasterMarkOfdByAdmin`,
            requestObj
          )
          .then(result => {
            if (result.body.returnmsg == 'Successful') {
               this.$fire({
                text: "Shipment Status Successfully Chanage to NDR",
                type: "success",
                timer: 30000
                }); 
               
               this.checkedvehicle=[];
               this.showData();
               this.markNdrreason=false;
            }else{
              this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 
            }
    
          })

          .catch(ex => {
            console.log("error", ex);
          });
    },
    // markNDR_approve:function(){
    //   var userdata = localStorage.getItem("userData");
    //   var userInfo = JSON.parse(userdata);
    //   this.markNdrmodal=false;
    //     var requestObj = {
    //     // deliveryagentmasterid: this.deliveryagent,
    //     // shippingid:this.shippingid,
    //     created_by:`${userInfo.sysemailid}`,

    //   };
    //   console.log("requestObj",requestObj);
    //   // return false;
    //    this.$http
    //       .post(
    //         `${CONSTANTS.MIGRATION_API_URL}/make_shipdeliveryrequest`,
    //         requestObj
    //       )
    //       .then(result => {
            
    
    //       })

    //       .catch(ex => {
    //         console.log("error", ex);
    //       });
    //       // this.showData();

    // },
    markNDRcancel:function(){
      this.markNdrreason=false;
    },

    refresh:function() {
      this.showData();
    },
  },
  // filters: {
  //   capitalize: function(value) {
  //     if (!value) return ''
  //     value = value.toString()
  //     return value.charAt(0).toUpperCase() + value.slice(1)
  //   }
  // }
};
</script>

